import { useQuery } from '@tanstack/react-query';

import { fetchData } from '..';

export const GET_CHARGE_CODES = 'api/posv3/pricing/GetChargeCodes';

export const chargeCodesQueryKey = ['charge-codes'];

export type ChargeCode = {
  ChargeCodeDesc: string;
  ChargeCodeGroupName: string | null;
  ChargeCodeId: number;
  ChargeCodeName: string;
  IsExactWeightBundle: boolean;
  PriceId: number;
  PricingTierGroupId: number | null;
  PricingTierPerProduct: boolean;
};

export function useChargeCodesQuery() {
  return useQuery({
    queryKey: chargeCodesQueryKey,
    queryFn: () => fetchData<ChargeCode[]>(GET_CHARGE_CODES),
  });
}
